import React, { useState } from "react";
import styles from "./ColorModalCarousel.module.scss";
import { ColorModal } from "@components/molecules/ColorModal";
import Image from "@components/atoms/Image";
import Button from "@components/atoms/Button";
import assetLoader from "@utils/internalImageLoder";

type Color = {
  name: string;
  modalImages: string[];
};

type Props = {
  selectedColor: Color;
  closeModal: () => void;
  modelName: string;
};

const ColorModalCarousel: React.FC<Props> = ({
  selectedColor,
  closeModal,
  modelName,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    if (selectedColor) {
      setCurrentImageIndex(
        (prev) => (prev + 1) % selectedColor?.modalImages?.length
      );
    }
  };

  const prevImage = () => {
    if (selectedColor) {
      setCurrentImageIndex(
        (prev) =>
          (prev - 1 + selectedColor?.modalImages?.length) %
          selectedColor?.modalImages?.length
      );
    }
  };

  const goToImage = (index: number) => {
    setCurrentImageIndex(index);
  };

  const isAtStart = currentImageIndex === 0;
  const isAtEnd = currentImageIndex === selectedColor?.modalImages?.length - 1;
  return (
    <ColorModal onClose={closeModal}>
      <div className={styles.modalHeader}>
        <div className={styles.modalTitleSection}>
          <h2 className={styles.modalTitle}>{modelName}</h2>
          <div className={styles.modalSubtitle}>
            <span>{selectedColor.name}</span>
            <span className={styles.arrow}>
              <Image
                src={`${assetLoader()}/icons/Chevron_right_grey.svg`}
                alt={"Right Arrow"}
                width={24}
                loading="lazy"
                height={24}
              />
            </span>
          </div>
        </div>
        <button className={styles.closeBtn} onClick={closeModal}>
          ✕
        </button>
      </div>
      <div className={styles.modalImageWrapper}>
        <div className={styles.modalImageContainer}>
          <Image
            src={selectedColor?.modalImages?.[currentImageIndex]}
            alt={`${selectedColor?.name} - View ${currentImageIndex + 1}`}
            width={450}
            height={267}
            loading="lazy"
            className={styles.modalImage}
          />
        </div>
      </div>

      <div className={styles.desktopModalNav}>
        <span className={styles.imageCounter}>
          {currentImageIndex + 1}/{selectedColor?.modalImages?.length}
        </span>
        <div className={styles.navButtons}>
          <Button
            onClick={prevImage}
            className={styles.arrowButton}
            disabled={isAtStart}
          >
            <Image
              src={`${assetLoader()}/icons/Carousal/ArrowLeft.svg`}
              alt={"Left Arrow"}
              className={styles.navIcon}
              width={20}
              height={20}
              loading="lazy"
            />
          </Button>
          <Button
            onClick={nextImage}
            className={styles.arrowButton}
            disabled={isAtEnd}
          >
            <Image
              src={`${assetLoader()}/icons/Carousal/ArrowRight.svg`}
              alt={"Right Arrow"}
              className={styles.navIcon}
              width={20}
              height={20}
              loading="lazy"
            />
          </Button>
        </div>
      </div>

      <div className={styles.mobileModalNav}>
        {selectedColor?.modalImages?.map((_, index) => (
          <button
            key={index}
            className={`${styles.modalDot} ${
              index === currentImageIndex ? styles.active : ""
            }`}
            onClick={() => goToImage(index)}
          />
        ))}
      </div>
    </ColorModal>
  );
};

export default ColorModalCarousel;
